import { Logger } from './logger';

const logger = new Logger('Analytics');

const HDIS_ANALYTICS_COOKIE_NAME = 'hdis_ga';

/** @TOASK not only related to analytics */
export const getHdisAnalyticsCookieValue = () => {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${HDIS_ANALYTICS_COOKIE_NAME.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
  ));

  const cookieValue = matches ? decodeURIComponent(matches[1]) : undefined;
  logger.debug(`cookie value of ${HDIS_ANALYTICS_COOKIE_NAME}:`, cookieValue);
  return cookieValue;
};

const setHdisAnalyticsCookieValue = (status: boolean) => {
  const expirationDate = new Date(Date.now() + 2592e+9).toUTCString(); // capped at 400 days (GA also sets the max expiration time)
  document.cookie = `${HDIS_ANALYTICS_COOKIE_NAME}=${status}; secure; samesite=strict; expires='max-age': ${expirationDate}`;
};

const removeHdisAnalyticsCookie = () => {
  const expirationDate = new Date(Date.now() - 1).toUTCString(); // expires instantly
  document.cookie = `${HDIS_ANALYTICS_COOKIE_NAME}=; secure; samesite=strict; expires='max-age': ${expirationDate}`;
};

const setGoogleAnalyticsConsent = (consent: boolean) => {
  /** @TOASK I need the check for gtag here because in preview and the current devlopment status it could be not defined */
  if (!window.gtag) {
    logger.warn('gtag is not defined');
    return;
  }

  if (consent) {
    window.gtag('consent', 'update', {
      analytics_storage: 'granted',
    });
  } else {
    window.gtag('consent', 'update', {
      analytics_storage: 'denied',
    });
  }
};

export const enableAnalytics = () => {
  logger.debug('google analytics enabled');

  setGoogleAnalyticsConsent(true);
  setHdisAnalyticsCookieValue(true);
};

export const disableAnalytics = () => {
  logger.debug('google analytics disabled');

  setGoogleAnalyticsConsent(false);
  setHdisAnalyticsCookieValue(false);
};

export const unsetAnalyticsPreferences = () => {
  logger.debug('google analytics unset');

  setGoogleAnalyticsConsent(false);
  removeHdisAnalyticsCookie();
};
